/** biome-ignore-all lint/style/useNamingConvention: legacy */
export const ADD_USER_LESSON_ERRORS = {
  USER_ROLE_DUPLICATE_ERROR: 'USER_ROLE_DUPLICATE_ERROR',
  USER_ROLE_NOT_MATCHING_IN_TEACHING_UNIT_LESSON: 'USER_ROLE_NOT_MATCHING_IN_TEACHING_UNIT_LESSON',
  LESSON_ORIGIN_FORBIDDEN_ERROR: 'LESSON_ORIGIN_FORBIDDEN_ERROR',
} as const;

export const DELETE_USER_LESSON_ERRORS = {
  USER_ROLE_NOT_FOUND: 'USER_ROLE_NOT_FOUND',
} as const;

export const LESSON_EDITABLE_VERSION_ERRORS = {
  INVALID_EDITORS: 'INVALID_EDITORS',
  MISSING_SEQUENCE: 'MISSING_SEQUENCE',
  SEQUENCE_NOT_FOUND: 'SEQUENCE_NOT_FOUND',
  SEQUENCE_HAS_NO_TITLE: 'SEQUENCE_HAS_NO_TITLE',
  SEQUENCE_TRAINING_HAS_NO_QUESTIONS: 'SEQUENCE_TRAINING_HAS_NO_QUESTIONS',
} as const;

export const LESSON_ERRORS = {
  DUPLICATE_CODE: 'DUPLICATE_CODE',
  LESSON_IN_COURSES: 'LESSON_IN_COURSES',
  LESSON_IN_ASSIGNMENTS: 'LESSON_IN_ASSIGNMENTS',
  LESSON_INVALID_SEQUENCE_TYPE: 'LESSON_INVALID_SEQUENCE_TYPE',
  LESSON_CONTENT_NOT_FOUND: 'LESSON_CONTENT_NOT_FOUND',
} as const;

export const LESSON_RESPONSIBLE_ERRORS = {
  USER_BLOCKED: 'LESSON_RESPONSIBLE_USER_BLOCKED',
  USER_DUPLICATE: 'LESSON_RESPONSIBLE_USER_DUPLICATE',
  USER_NOT_ELIGIBLE: 'LESSON_RESPONSIBLE_USER_NOT_ELIGIBLE',
  USER_NOT_FOUND: 'LESSON_RESPONSIBLE_USER_NOT_FOUND',
} as const;

export const ADD_EDITABLE_VERSION_ERRORS = {
  USER_ROLE_NOT_MATCHING: 'USER_ROLE_NOT_MATCHING',
  DUPLICATE: 'DUPLICATE',
} as const;

export const EDITABLE_VERSION_ERRORS = {
  FORBIDDEN_UPDATE: 'FORBIDDEN_UPDATE',
} as const;

export const EDIT_SEQUENCE_ERRORS = {
  SEQUENCE_LOCKED: 'SEQUENCE_LOCKED',
  UPDATE_FORBIDDEN: 'UPDATE_FORBIDDEN',
  BLOCK_NOT_FOUND: 'BLOCK_NOT_FOUND',
} as const;
